import React from 'react';
import {
	Form, Empty, Checkbox, Button, message, Col, Row, Input, Select, DatePicker, Space, Card, Radio, Spin,
	InputNumber, Descriptions, Divider
} from 'antd';
import { PushpinOutlined, CalendarOutlined, PlusOutlined, CloseOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { APIService } from '../../../../services/projectManager/api';
import { CalendarTimeService } from '../../../../services/calendar/calendar.tool.service.js';
import { __waterDocumentSvg } from '../../../../lib/waterMarking.js';
import Replacement from './Replacement.jsx'
import 'antd/dist/antd.css';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';

class FAInfo extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			isEdit: this.props.data.isEdit,
			loading: false,
			feeList: []
		};

		// this.formRef = React.createRef();
	}

	componentDidMount() {
		const userInfo = window.config.sysConfig ? window.config.sysConfig.userInfo : window.config;
		__waterDocumentSvg({
			container: document.getElementById('ProjectManager-FA'),
			// content: `${userInfo.user_department} ${userInfo.username} ${CalendarTimeService.getDayDate()}`,
			content : `${userInfo.user_department} ${userInfo.name} ${CalendarTimeService.getDayDate()}`,
			width: '700px',
			height: '550px',
			opacity: '0.1',
			fontSize: '26px',
			zIndex: 1000
		})
	}

	componentWillUnmount() {
		this.setState = (state, callback) => {
			return;
		};
	}

	onFinish = (formsValue) => {
		console.log('formsValue', formsValue);
		this.setState((prev, props) => {
			return { loading: true }
		})
		let values = {};
		Object.keys(formsValue).map(field => {
			if (formsValue[field] != undefined) {
				values[field] = formsValue[field]
			}
		})
		let param = {
			data: JSON.stringify(values),
		};
		APIService.SaveProject(param).then(res => {
			if (res.success) {
				message.success('提交投资交易及FA估值信息成功!');
			} else {
				message.error(res.error)
			}
			this.setState((prev, props) => {
				return { loading: false }
			})
		}).catch(err => {
			console.log('提交投资交易及FA估值信息 Error', err);
			this.setState((prev, props) => {
				return { loding: false }
			})
		})
	};


	// from置空
	eliminate = (f) => {
		this.props.formRef.current.resetFields([f]);
	}

	render() {
		const { isEdit, formData } = this.props.data;
		const { loading, feeList } = this.state;
		console.log(this.props.formRef.current.getFieldsValue());
		return (
			<div id="ProjectManager-FA">
				<Spin
					size="large"
					spinning={loading}
				>
					{/*
				<Form 
					ref={this.formRef}
					name="FA"
					labelAlign="left"
					layout="inline"
					onFinish={this.onFinish}
					initialValues={formData}
				>
					<Form.Item name="_id" hidden={true}><Input /></Form.Item>
			*/}
					<Row
						gutter={[8, 8]}
						style={{ width: '100%' }}
					>
						<Col span={24}>
							<Card
								title={<div className="form_title">账户信息</div>}
							>
								<Row gutter={[8, 8]} style={{ width: '100%' }}>
									<Col span={24}>
										<Descriptions
											bordered
											size="middle"
										>
											<Descriptions.Item
												label="拟开通证券账户"
												span={3}
											>
												<Row>
													<Col span={12}>
														<div className="highlight">
															<Form.Item
																name={["f46", "1"]}
															>
																<Select
																	mode="multiple"
																	disabled={!isEdit}
																	placeholder={"点击下拉选择"}
																	getPopupContainer={triggerNode => triggerNode.parentNode}
																>
																	<Select.Option value="证券资金户">证券资金户</Select.Option>
																	<Select.Option value="上海证券账户">上海证券账户</Select.Option>
																	<Select.Option value="深圳证券账户">深圳证券账户</Select.Option>
																</Select>
															</Form.Item>
														</div>
													</Col>
													<Col span={12}>
														<Form.Item
															name="f47"
														>
															<Input disabled={!isEdit} placeholder="请填写证券公司" bordered={false} />
														</Form.Item>
													</Col>
												</Row>
												<Divider />
												<Row>
													<Col span={12}>
														<div className="highlight">
															<Form.Item
																name={["f46", "2"]}
															>
																<Select
																	mode="multiple"
																	disabled={!isEdit}
																	placeholder={"点击下拉选择"}
																	getPopupContainer={triggerNode => triggerNode.parentNode}
																>
																	<Select.Option value="期货资金账户">期货资金账户</Select.Option>
																	<Select.Option value="交易编码">交易编码</Select.Option>
																</Select>
															</Form.Item>
														</div>
													</Col>
													<Col span={12}>
														<Form.Item
															name="f48"
														>
															<Input disabled={!isEdit} placeholder="请填写期货公司" bordered={false} />
														</Form.Item>
													</Col>
												</Row>
												<Divider />
												<div className="highlight">
													<Form.Item
														name={["f46", "3"]}
													>
														<Select
															mode="multiple"
															disabled={!isEdit}
															placeholder={"点击下拉选择"}
															getPopupContainer={triggerNode => triggerNode.parentNode}
														>
															<Select.Option value="中央国债">中央国债</Select.Option>
															<Select.Option value="上海清算所">上海清算所</Select.Option>
															<Select.Option value="外汇交易中心联网">外汇交易中心联网</Select.Option>
														</Select>
													</Form.Item>
												</div>
											</Descriptions.Item>
										</Descriptions>
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>

					<Row gutter={[8, 8]} style={{ width: '100%' }}>
						<Col span={24}>
							<Card
								title={<div className="form_title">估值信息</div>}
							>
								<Row gutter={[8, 8]} style={{ width: '100%' }}>
									<Col span={24}>
										<Descriptions
											bordered
											size="middle"
											column={2}
										>
											<Descriptions.Item
												label="估值基准日设置规则"
												span={2}
											>
												<Form.Item
													name="f49"
												>
													<Input.TextArea disabled={!isEdit} bordered={false} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="单位净值计算规则"
												span={2}
											>
												<div style={{ display: 'flex' }}>
													<Form.Item
														name="f50"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="单位净值保留小数点后四位,第五位舍位">单位净值保留小数点后四位,第五位舍位</Radio.Button>
															<Radio.Button value="每日单位净值归一">每日单位净值归一</Radio.Button>
															<Radio.Button value="其他">其他</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f50"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												label="固定费用的计提标准、计提频率和计提公式"
												span={2}
											>
												<Form.Item
													name="f51"
												>
													<Input.TextArea
														disabled={!isEdit}
														bordered={false}
														autoSize={{ minRows: 2, maxRows: 10 }}
													/>
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="浮动费用的计提标准、计提频率和计提公式"
												span={2}
											>
												<Form.Item
													name="f52"
												>
													<Input.TextArea
														disabled={!isEdit}
														bordered={false}
														autoSize={{ minRows: 2, maxRows: 14 }}
													/>
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="TOF类产品所投标的基金是否开放期错配"
												span={1}
											>
												<div style={{ display: 'flex' }}>
													<Form.Item
														name="f53"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="是">是</Radio.Button>
															<Radio.Button value="否">否</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f53"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												label="TOF类产品底层基金数据（交易确认单、单位净值/虚拟净值、份额对账单）获取方式和获取时间"
												span={1}
											>
												<Form.Item
													name="f54"
												>
													<Input.TextArea disabled={!isEdit} bordered={false} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="特殊估值安排"
												span={2}
											>
												<Form.Item
													name="f55"
												>
													<Input.TextArea disabled={!isEdit} bordered={false} />
												</Form.Item>
											</Descriptions.Item>
										</Descriptions>
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>

					<Row
						gutter={[8, 8]}
						style={{ width: '100%' }}
					>
						<Col span={24}>
							<Card
								title={<div className="form_title">资金信息</div>}
							>
								<Row gutter={[8, 8]} style={{ width: '100%' }}>
									<Col span={24}>
										<Descriptions
											size="middle"
											bordered
											column={2}
										>
											<Descriptions.Item
												label="申购赎回频率"
											>
												<Row>
													<Col span={24}>
														<div style={{ display: 'flex' }}>
															<Form.Item
																name="f56"
															>
																<Radio.Group buttonStyle="solid" disabled={!isEdit}>
																	<Radio.Button value="月度">月度</Radio.Button>
																	<Radio.Button value="季度">季度</Radio.Button>
																	<Radio.Button value="备注">备注</Radio.Button>
																</Radio.Group>
															</Form.Item>
															{
																isEdit && <Replacement formRef={this.props.formRef} subscript={"f56"}/>
															}
														</div>
													</Col>
													<Col span={24}>
														<Form.Item
															name="f58"
														>
															<Input.TextArea
																placeholder="请填写备注"
																disabled={!isEdit}
																bordered={false}
																autoSize={{ minRows: 2, maxRows: 10 }}
															/>
														</Form.Item>
													</Col>
												</Row>

											</Descriptions.Item>
											<Descriptions.Item
												label="付款时点"
											>
												<Row>
													<Col span={24}>
														<div style={{ display: 'flex' }}>

															<Form.Item
																name="f57"
															>
																<Radio.Group buttonStyle="solid" disabled={!isEdit}>
																	<Radio.Button value="T+5">T+5</Radio.Button>
																	<Radio.Button value="备注">备注</Radio.Button>
																</Radio.Group>
															</Form.Item>
															{
																isEdit && <Replacement formRef={this.props.formRef} subscript={"f57"}/>
															}
														</div>
													</Col>
													<Col span={24}>
														<Form.Item
															name="f59"
														>
															<Input.TextArea
																placeholder="请填写备注"
																disabled={!isEdit}
																bordered={false}
																autoSize={{ minRows: 2, maxRows: 10 }}
															/>
														</Form.Item>
													</Col>
												</Row>

											</Descriptions.Item>
											<Descriptions.Item
												label="保障基金认缴方式"
												span={2}
											>
												<Row>
													<Col span={24}>
														<div style={{ display: 'flex' }}>
															<Form.Item
																name="f60"
															>
																<Radio.Group buttonStyle="solid" disabled={!isEdit}>
																	<Radio.Button value="委托人支付">委托人支付</Radio.Button>
																	<Radio.Button value="自有垫付">自有垫付</Radio.Button>
																	<Radio.Button value="信托资金支付">信托资金支付</Radio.Button>
																	<Radio.Button value="不缴">不缴</Radio.Button>
																	<Radio.Button value="备注">备注</Radio.Button>
																</Radio.Group>
															</Form.Item>
															{
																isEdit && <Replacement formRef={this.props.formRef} subscript={"f60"}/>
															}
														</div>
													</Col>
												</Row>
											</Descriptions.Item>
										</Descriptions>
										<Row gutter={[2, 2]}>
											<Col span={8}>
												<div className="trash_info_title">费用类型</div>
											</Col>
											<Col span={8}>
												<div className="trash_info_title">付费频率</div>
											</Col>
											<Col span={8}>
												<div className="trash_info_title">支付方式</div>
											</Col>
										</Row>
										<Form.List
											name="fee"
										>
											{(fields, { add, remove }) => (
												<Card>
													{fields.map((field, index) => (
														<Row
															gutter={[8, 8]}
															style={{ width: "100%" }}
															key={field.key}
														>
															<Col span={8}>
																<Form.Item name={[field.name, '_id']} hidden={true}></Form.Item>
																<Form.Item
																	name={[field.name, 'f61']}
																	fieldKey={[field.fieldKey, 'f61']}

																>
																	<Input placeholder="请输入费用类型名称" disabled={!isEdit} />
																</Form.Item>
															</Col>
															<Col span={9}>
																<Form.Item
																	name={[field.name, 'f6']}
																	fieldKey={[field.fieldKey, 'f6']}

																>
																	<Radio.Group buttonStyle="solid" disabled={!isEdit}>
																		<Radio.Button value="月度">月度</Radio.Button>
																		<Radio.Button value="季度">季度</Radio.Button>
																		<Radio.Button value="年度">年度</Radio.Button>
																		<Radio.Button value="备注">备注</Radio.Button>
																	</Radio.Group>
																</Form.Item>
															</Col>
															<Col span={6}>
																<Form.Item
																	noStyle
																	shouldUpdate={(prevValues, currentValues) => prevValues.fee !== currentValues.fee}
																>
																	{({ getFieldValue }) =>
																		getFieldValue(['fee', field.name, 'f6']) === "备注" ? (
																			<Form.Item
																				name={[field.name, 'f7']}
																				fieldKey={[field.fieldKey, 'f7']}
																			>
																				<Input placeholder="请输入支付方式" disabled={!isEdit} />
																			</Form.Item>
																		) : null
																	}
																</Form.Item>
															</Col>
															<Col span={1}>
																{
																	isEdit &&
																	<Space>
																		<MinusCircleOutlined onClick={() => remove(field.name)} />
																		<PlusOutlined onClick={() => add()} />
																	</Space>
																}

															</Col>
														</Row>
													))}
													<Row gutter={[8, 8]} style={{ width: "100%" }}>
														<Col span={24}>
															<Form.Item>
																<Button type="dashed" onClick={() => add()} block disabled={!isEdit}>新增费用</Button>
															</Form.Item>
														</Col>
													</Row>
												</Card>
											)}

										</Form.List>
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>

					<Row
						gutter={[8, 8]}
						style={{ width: '100%' }}
					>
						<Col span={24}>
							<Card
								title={<div className="form_title">交易风控</div>}
							>
								<Row gutter={[8, 8]} style={{ width: '100%' }}>
									<Col span={24}>
										<Descriptions
											size="middle"
											bordered
											column={2}
										>
											<Descriptions.Item
												label="投资范围"
												span={2}
											>
												<Form.Item
													name="f62"
												>
													<Input.TextArea disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="预警线"
											>
												<Form.Item
													name="f63"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="平仓线"
											>
												<Form.Item
													name="f64"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="预警平仓监控日"
											>
												<Row>
													<Col span={24}>
														<div style={{ display: 'flex' }}>

															<Form.Item
																name="f65"
															>
																<Radio.Group buttonStyle="solid" disabled={!isEdit}>
																	<Radio.Button value="同估值基准日">同估值基准日</Radio.Button>
																	<Radio.Button value="其他">其他</Radio.Button>
																</Radio.Group>
															</Form.Item>
															{
																isEdit && <Replacement formRef={this.props.formRef} subscript={"f65"}/>
															}
														</div>
													</Col>
													<Col span={24}>
														<Form.Item
															name="f67"
														>
															<Input placeholder="请填写其他监控日" disabled={!isEdit} />
														</Form.Item>
													</Col>
												</Row>

											</Descriptions.Item>
											<Descriptions.Item
												label="预警平仓净值基准"
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f66"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="单位净值">单位净值</Radio.Button>
															<Radio.Button value="累计单位净值">累计单位净值</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f66"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												label="触发预警后的动作"
											>
												<Row gutter={[5, 5]}>
													<Col span={24}>
														<div style={{ display: 'flex' }}>

															<Form.Item
																name="f68"
															>
																<Radio.Group buttonStyle="solid" disabled={!isEdit}>
																	<Radio.Button value="定向信披">定向信披</Radio.Button>
																	<Radio.Button value="官网信批">官网信批</Radio.Button>
																	<Radio.Button value="减仓">减仓</Radio.Button>
																	<Radio.Button value="禁止买入权限">禁止买入权限</Radio.Button>
																	<Radio.Button value="其他">其他</Radio.Button>
																</Radio.Group>
															</Form.Item>
															{
																isEdit && <Replacement formRef={this.props.formRef} subscript={"f68"}/>
															}
														</div>
													</Col>
													<Col span={24}>
														<Form.Item
															name="f70"
														>
															<Input disabled={!isEdit} placeholder="请填写其他预警动作" />
														</Form.Item>
													</Col>
												</Row>

											</Descriptions.Item>
											<Descriptions.Item
												label="预警减仓方案"
											>
												<Form.Item
													name="f69"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="触发平仓后的执行方案"
												span={2}
											>
												<Form.Item
													name="f71"
												>
													<Input.TextArea
														autoSize={{ minRows: 1, maxRows: 10 }}
														disabled={!isEdit}
													/>
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="风控定向信批路径"
												span={2}
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f72"
													>
														{/* <Input disabled={!isEdit}/> */}
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="信托合同预留授权邮箱">信托合同预留授权邮箱</Radio.Button>
															<Radio.Button value="投顾协议预留授权邮箱">投顾协议预留授权邮箱</Radio.Button>
															<Radio.Button value="其他">其他</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f72"}/>
													}
												</div>

											</Descriptions.Item>
											<Descriptions.Item
												label="集中度控制核算口径"
												span={2}
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f73"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="按买入成本">按买入成本</Radio.Button>
															<Radio.Button value="按持仓市值">按持仓市值</Radio.Button>
															<Radio.Button value="按买入成本和持仓市值孰低">按买入成本和持仓市值孰低</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f73"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												label="投资限制条款（禁投要求、集中度要求）"
												span={2}
											>
												<Form.Item
													name="f74"
												>
													<Input.TextArea disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="到期禁止买入日期"
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f75"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="到期日前第15个交易日">到期日前第15个交易日</Radio.Button>
															<Radio.Button value="到期日前第10个交易日">到期日前第10个交易日</Radio.Button>
															<Radio.Button value="不做书面约定">不做书面约定</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f75"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												label="到期清空持仓日期"
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f76"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="到期日前第5个交易日">到期日前第5个交易日</Radio.Button>
															<Radio.Button value="不做书面约定">不做书面约定</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f76"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												label="到期结束变现安排"
												span={2}
											>
												<Form.Item
													name="f77"
												>
													<Input.TextArea disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
										</Descriptions>
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>

					<Row
						gutter={[8, 8]}
						style={{ width: '100%' }}
					>
						<Col span={24}>
							<Card
								title={<div className="form_title">信息披露</div>}
							>
								<Row
									gutter={[8, 8]}
									style={{ width: '100%' }}
								>
									<Col span={24}>
										<Descriptions
											size="middle"
											bordered
											column={2}
										>
											<Descriptions.Item
												label="是否需要披露净值"
											>
												<Row>
													<Col span={12}>
														<div style={{ display: 'flex' }}>

															<Form.Item
																name="f78"
															>
																<Radio.Group buttonStyle="solid" disabled={!isEdit}>
																	<Radio.Button value="是">是</Radio.Button>
																	<Radio.Button value="否">否</Radio.Button>
																	<Radio.Button value="备注">备注</Radio.Button>
																</Radio.Group>
															</Form.Item>
															{
																isEdit && <Replacement formRef={this.props.formRef} subscript={"f78"}/>
															}
														</div>
													</Col>
													<Col span={12}>
														<Form.Item
															name="f80"
														>
															<Input disabled={!isEdit} placeholder="请填写备注" />
														</Form.Item>
													</Col>
												</Row>

											</Descriptions.Item>
											<Descriptions.Item
												label="披露频率"
											>
												<Row>
													<Col span={12}>
														<div style={{ display: 'flex' }}>

															<Form.Item
																name="f79"
															>
																<Radio.Group buttonStyle="solid" disabled={!isEdit}>
																	<Radio.Button value="每周">每周</Radio.Button>
																	<Radio.Button value="每月">每月</Radio.Button>
																	<Radio.Button value="备注">备注</Radio.Button>
																</Radio.Group>
															</Form.Item>
															{
																isEdit && <Replacement formRef={this.props.formRef} subscript={"f79"}/>
															}
														</div>
													</Col>
													<Col span={12}>
														<Form.Item
															name="f81"
														>
															<Input disabled={!isEdit} placeholder="请填写备注" />
														</Form.Item>
													</Col>
												</Row>

											</Descriptions.Item>
											<Descriptions.Item
												label="是否需要披露信托管理报告"
											>
												<Row>
													<Col span={12}>
														<div style={{ display: 'flex' }}>

															<Form.Item
																name="f82"
															>
																<Radio.Group buttonStyle="solid" disabled={!isEdit}>
																	<Radio.Button value="是">是</Radio.Button>
																	<Radio.Button value="否">否</Radio.Button>
																	<Radio.Button value="备注">备注</Radio.Button>
																</Radio.Group>
															</Form.Item>
															{
																isEdit && <Replacement formRef={this.props.formRef} subscript={"f82"}/>
															}
														</div>
													</Col>
													<Col span={12}>
														<Form.Item
															name="f84"
														>
															<Input disabled={!isEdit} placeholder="请填写备注" />
														</Form.Item>
													</Col>
												</Row>

											</Descriptions.Item>
											<Descriptions.Item
												label="报告频率"
											>
												<Row>
													<Col span={12}>
														<div style={{ display: 'flex' }}>

															<Form.Item
																name="f83"
															>
																<Radio.Group buttonStyle="solid" disabled={!isEdit}>
																	<Radio.Button value="月度">月度</Radio.Button>
																	{/* <Radio.Button value="每月">每月</Radio.Button> */}
																	<Radio.Button value="季度">季度</Radio.Button>
																	<Radio.Button value="备注">备注</Radio.Button>
																</Radio.Group>
															</Form.Item>
															{
																isEdit && <Replacement formRef={this.props.formRef} subscript={"f83"}/>
															}
														</div>
													</Col>
													<Col span={12}>
														<Form.Item
															name="f85"
														>
															<Input disabled={!isEdit} placeholder="请填写备注" />
														</Form.Item>
													</Col>
												</Row>
											</Descriptions.Item>
											<Descriptions.Item
												label="特殊/临时信息披露安排"
												span={1}
											>
												<Form.Item
													name="f86"
												>
													<Input.TextArea disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="信托经理（信托事务管理报告落款处，按合同预留人填写）"
												span={1}
											>
												<Form.Item
													name="f187"
												>
													<Input.TextArea disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
										</Descriptions>
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>

					<Row
						gutter={[8, 8]}
						style={{ width: '100%' }}
					>
						<Col span={24}>
							<Card
								title={<div className="form_title">联系人</div>}
							>
								<Row
									gutter={[8, 8]}
									style={{ width: '100%' }}
								>
									<Col span={24}>
										<Descriptions
											size="middle"
											bordered
											column={2}
										>
											<Descriptions.Item
												label="投资管理人名称"
												span={2}
											>
												<Form.Item
													name="f87"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="投资管理人联系人"
											>
												<Form.Item
													name="f185"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="电话/传真/邮箱"
											>
												<Form.Item
													name="f88"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="托管行联系人"
											>
												<Form.Item
													name="f89"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="电话/传真/邮箱"
											>
												<Form.Item
													name="f90"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="券商联系人"
											>
												<Form.Item
													name="f91"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="电话/传真/邮箱"
											>
												<Form.Item
													name="f92"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="期货商联系人"
											>
												<Form.Item
													name="f93"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="电话/传真/邮箱"
											>
												<Form.Item
													name="f94"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="PB系统技术支持人"
											>
												<Form.Item
													name="f95"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="电话/传真/邮箱"
											>
												<Form.Item
													name="f96"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
										</Descriptions>
									</Col>
								</Row>
							</Card>

						</Col>
					</Row>
					{/*	
				</Form>
				*/}
				</Spin>
			</div>
		)
	}
}

export default FAInfo;


// WEBPACK FOOTER //
// app/components/customPage/project-manager/Pages/FAInfo.jsx